<div 
  *ngIf="batteryPercent > 0 && !hasError && isMatchInProgress" 
  class="battery-indicator"
  [attr.data-battery-level]="getBatteryLevelClass()"
  role="status"
  aria-label="Battery level indicator"
  [attr.aria-live]="'polite'">
  <ion-icon 
    [name]="batteryIcon"
    [style.color]="batteryColor"
    class="battery-icon"
    aria-hidden="true">
  </ion-icon>
  <span 
    [style.color]="batteryColor"
    class="battery-percentage"
    [attr.aria-label]="'Battery level: ' + batteryPercent + ' percent'">
    {{ batteryPercent }}%
  </span>
</div>

<div 
  *ngIf="hasError" 
  class="battery-error"
  role="alert"
  aria-label="Battery indicator error">
  <ion-icon name="warning-outline" class="error-icon"></ion-icon>
  <span class="error-text">{{ 'Battery data unavailable' | translate }}</span>
</div> 